@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent content editor-portfolio-result-detail">
    <irb-editor-sidebar-banner
      [accordian]="accordian"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [isModified]="isModified"
      [isValid]="isValid"
      [hasPendingFunction]="hasPendingFunction"
      [slot]="slot"
      (save)="save()"
      (cancel)="cancelChanges()">
      <span header class="ms-header" tooltip [tooltipTitle]="'Portfolio Result Detail'" [tooltipRequiresTruncation]="true">Portfolio Result Detail</span>
      <button class="btn-medium-secondary"
        buttonsInMiddle
        style="width: 100px;"
        data-export-pdf-button [disabled]="hasError || actionState.isUnresolved"
      (click)="exportPDF()">Export PDF</button>
      <button class="btn-medium-secondary"
        buttonsInMiddle
        [disabled]="!hasExplanation"
      (click)="showExplanation()">View Explanations</button>
      <span buttonsInEnd>
        <button style="position: relative;" [matMenuTriggerFor]="subMenuSAC" class="btn-medium-secondary btnWithArrow"
          >Go to SAC<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
          <mat-menu #subMenuSAC="matMenu" class="nav__items_action_btn" yPosition="below">
            <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_BAL','_blank')">Balances</button>
            <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_POS','_blank')">Positions</button>
            <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_TRAN','_blank')">Transactions</button>
            <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_COST','_blank')">Cost Basis</button>
            <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=R_MARK','_blank')">Research</button>
          </mat-menu>
        </button>
      </span>
      @if (data && !hasError) {
        <irb-com-pr-action-buttons style="/*margin-left: auto; margin-right: 20px*/ width: calc(100% - 300px);" buttonsInEnd [state]="actionState"
        [data]="data" [isModified]="isModified" [isAutomated]="isAutomated"></irb-com-pr-action-buttons>
      }
    </irb-editor-sidebar-banner>
    @if (portfolioIds && portfolioIds.length > 1 && !previousRebelId) {
      <div class="previous-next">
        <a data-previous (click)="getPreviousPortfolio()" [class.disabled]="isFirstPortfolio || showUnsavedChangesWarning"><
        Previous</a>&ensp;&ensp;
        &ensp;&ensp;
        <span> --<b>{{getPortfolioPosition}}</b></span> of <span>{{portfolioIds.length}}-- </span>
        &ensp;&ensp;
        <a data-next (click)="getNextPortfolio()" [class.disabled]="isLastPortfolio || showUnsavedChangesWarning">Next ></a>
      </div>
    }
    @if (previousRebelId) {
      <div class="last-result-label-container" data-last-result-label>
        <div class="last-result-label">
          [Viewing last rebalance result]
        </div>
      </div>
    }
    <div class="body" [style.height]="bodyHeight" #body>
      <div class="block">
        @if (data && !hasError) {
          <irb-com-pr-info-banner [(data)]="data"
          (change)="onInputChange(ignoreList)"></irb-com-pr-info-banner>
        }
        @if (data && !hasError) {
          <irb-com-pr-action-panel [state]="actionState" [data]="data"
          [isModified]="isModified" [isAutomated]="isAutomated"></irb-com-pr-action-panel>
        }
      </div>
      <div class="block">
        <mat-accordion #accordian="matAccordion" [multi]="true">
          <mat-expansion-panel id="SUMMARY" class="editor-portfolio-result-detail-com-summary"
            [expanded]="localEditorsService.getDefaultExpansionState('SUMMARY')"
            (opened)="localEditorsService.updateExpansionState('SUMMARY','opened')"
            (closed)="localEditorsService.updateExpansionState('SUMMARY','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Summary
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data && !hasError) {
                <irb-com-pr-summary [data]="data" (change)="handleTradeExplanationChange()"></irb-com-pr-summary>
              }
            </ng-template>
          </mat-expansion-panel>
          <mat-expansion-panel id="CASH_VALUES" [expanded]="localEditorsService.getDefaultExpansionState('CASH_VALUES') && !actionState.isUnresolved"
            (opened)="localEditorsService.updateExpansionState('CASH_VALUES','opened')"
            (closed)="localEditorsService.updateExpansionState('CASH_VALUES','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Cash Values
                <span (click)="$event.stopPropagation()" class="infoIcon" calltoaction
                  [calltoactionTemplate]="irbColInfoTemplateRef">
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data && !hasError) {
                <irb-com-pr-cash-values [data]="data"
                (change)="onInputChange(ignoreList)" [pdfExportConfig]="pdfExportConfig" (pdfExportConfigChange)="onPDFExportConfigChange($event)"></irb-com-pr-cash-values>
              }
            </ng-template>
          </mat-expansion-panel>
          <mat-expansion-panel id="ORDERS" [expanded]="localEditorsService.getDefaultExpansionState('ORDERS') && !actionState.isUnresolved"
            (opened)="localEditorsService.updateExpansionState('ORDERS','opened')"
            (closed)="localEditorsService.updateExpansionState('ORDERS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Orders
                <span (click)="$event.stopPropagation()" class="infoIcon" calltoaction
                [calltoactionTemplate]="irbColInfoTemplateRef"></span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (data && highLevelInfoDto && !hasError) {
                <irb-com-pr-orders [(data)]="data" [isAutomated]="isAutomated"
                (change)="onInputChange(ignoreList)" [pdfExportConfig]="pdfExportConfig" (pdfExportConfigChange)="onPDFExportConfigChange($event)"></irb-com-pr-orders>
              }
            </ng-template>
          </mat-expansion-panel>
          @if (!ENABLE_SEC_GRID_CHART) {
            <mat-expansion-panel id="ALLOCATIONS" [expanded]="localEditorsService.getDefaultExpansionState('ALLOCATIONS') && !actionState.isUnresolved"
              (opened)="localEditorsService.updateExpansionState('ALLOCATIONS','opened')"
              (closed)="localEditorsService.updateExpansionState('ALLOCATIONS','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Allocations
                  <span (click)="$event.stopPropagation()" class="infoIcon" calltoaction
                  [calltoactionTemplate]="irbColInfoTemplateRef"></span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (data && !hasError) {
                  <irb-com-pr-allocations-legacy [(data)]="data"
                  (change)="onInputChange(ignoreList)"></irb-com-pr-allocations-legacy>
                }
              </ng-template>
            </mat-expansion-panel>
          }
          @if (ENABLE_SEC_GRID_CHART) {
            <mat-expansion-panel id="ALLOCATIONS" [expanded]="localEditorsService.getDefaultExpansionState('ALLOCATIONS') && !actionState.isUnresolved"
              (opened)="localEditorsService.updateExpansionState('ALLOCATIONS','opened')"
              (closed)="localEditorsService.updateExpansionState('ALLOCATIONS','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Allocations
                  <span (click)="$event.stopPropagation()" class="infoIcon" calltoaction
                  [calltoactionTemplate]="irbColInfoTemplateRef"></span>
                  <span style="margin-left: auto">
                    <button class="btn-slim-primary maximize-right" (click)="$event.stopPropagation(); openViewPrdAllocations();">Open in new window</button>
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (data && !hasError) {
                <mat-tab-group style="clear: both;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="allocationsTabIndex">
                  <mat-tab label="Positions">
                    <ng-template matTabContent>
                      <irb-com-pr-allocations [groupOption]="'ungroupedAllocLabel'" [data]="data" (change)="onInputChange(ignoreList)" [canTransmitData]="true" [pdfExportConfig]="pdfExportConfig" (pdfExportConfigChange)="onPDFExportConfigChange($event)"></irb-com-pr-allocations>
                    </ng-template>
                  </mat-tab>
                  @if (ENABLE_SEC_GRID_CHART) {
                    <mat-tab label="Schwab Asset Classes">
                      <ng-template matTabContent>
                        <irb-com-pr-allocations [groupOption]="'ACLevel'" [data]="data" (change)="onInputChange(ignoreList)" [canTransmitData]="true" [pdfExportConfig]="pdfExportConfig" (pdfExportConfigChange)="onPDFExportConfigChange($event)"></irb-com-pr-allocations>
                      </ng-template>
                    </mat-tab>
                  }
                  <mat-tab [label]="data.envGlobalSettingsDTO?.securityCustAttrAbbr">
                    <ng-template matTabContent>
                      <irb-com-pr-allocations [groupOption]="'SecCustCatAllocLabel'" [data]="data" (change)="onInputChange(ignoreList)" [canTransmitData]="true" [pdfExportConfig]="pdfExportConfig" (pdfExportConfigChange)="onPDFExportConfigChange($event)"></irb-com-pr-allocations>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="Morningstar Stock Style">
                    <ng-template matTabContent>
                      <irb-com-pr-allocations [groupOption]="'styleBoxLabel'" [data]="data" (change)="onInputChange(ignoreList)" [canTransmitData]="true" [pdfExportConfig]="pdfExportConfig" (pdfExportConfigChange)="onPDFExportConfigChange($event)"></irb-com-pr-allocations>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="Security Type">
                    <ng-template matTabContent>
                      <irb-com-pr-allocations [groupOption]="'sacSecurityType'" [data]="data" (change)="onInputChange(ignoreList)" [canTransmitData]="true" [pdfExportConfig]="pdfExportConfig" (pdfExportConfigChange)="onPDFExportConfigChange($event)"></irb-com-pr-allocations>
                    </ng-template>
                  </mat-tab>
                </mat-tab-group>
              }
            </mat-expansion-panel>
          }
          @if (!ENABLE_SEC_GRID_CHART) {
            <mat-expansion-panel id="ALLOCATION_CHART"
              [expanded]="localEditorsService.getDefaultExpansionState('ALLOCATION_CHART')  && !actionState.isUnresolved"
              (opened)="localEditorsService.updateExpansionState('ALLOCATION_CHART','opened')"
              (closed)="localEditorsService.updateExpansionState('ALLOCATION_CHART','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Allocation Chart
                  <span (click)="$event.stopPropagation()" class="infoIcon" calltoaction
                  [calltoactionTemplate]="irbColInfoTemplateRef"></span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                @if (data && !hasError) {
                  <irb-com-pr-allocation-chart-legacy [(data)]="data"
                  (change)="onInputChange(ignoreList)"></irb-com-pr-allocation-chart-legacy>
                }
              </ng-template>
            </mat-expansion-panel>
          }
          @if (ENABLE_SEC_GRID_CHART) {
            <mat-expansion-panel id="ALLOCATION_CHART"
              [expanded]="localEditorsService.getDefaultExpansionState('ALLOCATION_CHART')  && !actionState.isUnresolved"
              (opened)="localEditorsService.updateExpansionState('ALLOCATION_CHART','opened')"
              (closed)="localEditorsService.updateExpansionState('ALLOCATION_CHART','closed')">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Allocations Charts
                  <span (click)="$event.stopPropagation()" class="infoIcon" calltoaction
                  [calltoactionTemplate]="irbColInfoTemplateRef"></span>
                  <span style="margin-left: auto">
                    <button class="btn-slim-primary maximize-right" style="margin-right: 10px;" (click)="$event.stopPropagation(); openViewPrdAllocationChart();">Open in new window</button>
                    <button class="btn-slim-primary settings-right" style="margin-right: 10px;" (click)="$event.stopPropagation(); showCustomView = true;" [disabled]="showCustomView">Customize view</button>
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (data && !hasError) {
                <irb-com-pr-allocation-chart [data]="data" [(showCustomView)]="showCustomView" [pdfExportConfig]="pdfExportConfig" (pdfExportConfigChange)="onPDFExportConfigChange($event)"></irb-com-pr-allocation-chart>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
      <ng-template #irbColInfoTemplateRef><a href="{{userdata?.tutorials}}" target="_blank">View Tutorial</a>
    </ng-template>
  </div>
</div>
}
